import { render } from "./InitLayout.vue?vue&type=template&id=95ee1c4c&ts=true"
import script from "./InitLayout.vue?vue&type=script&lang=ts"
export * from "./InitLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__